module.exports = __webpack_public_path__ + "static/get-ready-2-1acec3cc1ec3b602b46411d96719be2a.png";